/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoTraumaDTO
 */
export interface AssistitoTraumaDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoTraumaDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTraumaDTO
     */
    trauma?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTraumaDTO
     */
    posizione?: string;
    /**
     * 
     * @type {Date}
     * @memberof AssistitoTraumaDTO
     */
    dataTrauma?: Date;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTraumaDTO
     */
    causa?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTraumaDTO
     */
    dannoProvocato?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTraumaDTO
     */
    terapia?: string;
}

/**
 * Check if a given object implements the AssistitoTraumaDTO interface.
 */
export function instanceOfAssistitoTraumaDTO(value: object): value is AssistitoTraumaDTO {
    return true;
}

export function AssistitoTraumaDTOFromJSON(json: any): AssistitoTraumaDTO {
    return AssistitoTraumaDTOFromJSONTyped(json, false);
}

export function AssistitoTraumaDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoTraumaDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'trauma': json['trauma'] == null ? undefined : json['trauma'],
        'posizione': json['posizione'] == null ? undefined : json['posizione'],
        'dataTrauma': json['dataTrauma'] == null ? undefined : (new Date(json['dataTrauma'])),
        'causa': json['causa'] == null ? undefined : json['causa'],
        'dannoProvocato': json['dannoProvocato'] == null ? undefined : json['dannoProvocato'],
        'terapia': json['terapia'] == null ? undefined : json['terapia'],
    };
}

export function AssistitoTraumaDTOToJSON(value?: AssistitoTraumaDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'trauma': value['trauma'],
        'posizione': value['posizione'],
        'dataTrauma': value['dataTrauma'] == null ? undefined : ((value['dataTrauma'] as any).toISOString()),
        'causa': value['causa'],
        'dannoProvocato': value['dannoProvocato'],
        'terapia': value['terapia'],
    };
}

